import React from 'react';

import InterpretationPage01 from '../poslumaInterpretation/InterpretationPage01';
import InterpretationPage10 from '../poslumaInterpretation/InterpretationPage10';
import InterpretationPage11 from '../poslumaInterpretation/InterpretationPage11';
import InterpretationPage12 from '../poslumaInterpretation/InterpretationPage12';
import InterpretationPage13 from '../poslumaInterpretation/InterpretationPage13';
import InterpretationPage14 from '../poslumaInterpretation/InterpretationPage14';
import AcquisitionPage01 from '../poslumaAcquisition/AcquisitionPage01';
import AcquisitionPage02 from '../poslumaAcquisition/AcquisitionPage02';
import AcquisitionPage03 from '../poslumaAcquisition/AcquisitionPage03';
import AcquisitionPage04 from '../poslumaAcquisition/AcquisitionPage04';
import AcquisitionPage05 from '../poslumaAcquisition/AcquisitionPage05';
import AcquisitionPage06 from '../poslumaAcquisition/AcquisitionPage06';
import AcquisitionPage07 from '../poslumaAcquisition/AcquisitionPage07';
import AcquisitionPage08 from '../poslumaAcquisition/AcquisitionPage08';
import AcquisitionPage09 from '../poslumaAcquisition/AcquisitionPage09';

type MainPageProps = {
  module: string;
  page: number;
  setNextDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  setNextDisabledCS: React.Dispatch<React.SetStateAction<boolean>>;
};

const MainPagePosluma = ({ module, page, setNextDisabled, setNextDisabledCS }: MainPageProps): JSX.Element => {
  const renderMainPage = () => {
    if (module === 'poslumaInterpretation') {
      switch (page) {
        case 1: {
          return <InterpretationPage01 />;
        }
        // Note: Pages 2 through 9 should point to the Acquisition components
        // However, we still need the module prop to be poslumaAcquisition
        case 2: {
          return <AcquisitionPage02 />;
        }
        case 3: {
          return <AcquisitionPage03 setNextDisabled={setNextDisabled} />;
        }
        case 4: {
          return <AcquisitionPage04 />;
        }
        case 5: {
          return <AcquisitionPage05 />;
        }
        case 6: {
          return <AcquisitionPage06 setNextDisabled={setNextDisabled} />;
        }
        case 7: {
          return <AcquisitionPage07 setNextDisabled={setNextDisabled} />;
        }
        case 8: {
          return <AcquisitionPage08 setNextDisabled={setNextDisabled} />;
        }
        case 9: {
          return <AcquisitionPage09 />;
        }
        case 10: {
          return <InterpretationPage10 />;
        }
        case 11: {
          return <InterpretationPage11 />;
        }
        case 12: {
          return <InterpretationPage12 setNextDisabled={setNextDisabled} setNextDisabledCS={setNextDisabledCS} />;
        }
        case 13: {
          return <InterpretationPage13 setNextDisabled={setNextDisabled} setNextDisabledCS={setNextDisabledCS} />;
        }
        case 14: {
          return <InterpretationPage14 />;
        }
        default: {
          return null;
        }
      }
    }
    if (module === 'poslumaAcquisition') {
      switch (page) {
        case 1: {
          return <AcquisitionPage01 />;
        }
        case 2: {
          return <AcquisitionPage02 />;
        }
        case 3: {
          return <AcquisitionPage03 setNextDisabled={setNextDisabled} />;
        }
        case 4: {
          return <AcquisitionPage04 />;
        }
        case 5: {
          return <AcquisitionPage05 />;
        }
        case 6: {
          return <AcquisitionPage06 setNextDisabled={setNextDisabled} />;
        }
        case 7: {
          return <AcquisitionPage07 setNextDisabled={setNextDisabled} />;
        }
        case 8: {
          return <AcquisitionPage08 setNextDisabled={setNextDisabled} />;
        }
        case 9: {
          return <AcquisitionPage09 />;
        }
        default: {
          return null;
        }
      }
    }
    return null;
  };

  return (
    <>
      {/* We call the proper component based on the page we are on */}
      {page && renderMainPage()}
    </>
  );
};

export default MainPagePosluma;
